import { useBrand } from '../../../shared/branding/brand-provider';
import styles from './Logo.module.css';

/** Default Revelio Labs sidebar logo (33x33 badge) */
export const RevelioSidebarLogo = () => {
  return (
    <span className={styles.badge}>
      <svg
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M33 16.5C33 25.6137 25.6124 33 16.5 33C7.38762 33 0 25.6137 0 16.5C0 7.38633 7.38762 0 16.5 0L33 16.5Z"
          fill="var(--rl-logo-circle, #25282D)"
        />
        <path
          d="M19.5654 8.80811H22.7688V24.1918H19.5654V8.80811Z"
          fill="var(--rl-logo-text, #fff)"
        />
        <path
          d="M10.2313 12.8958H13.4346V14.667C14.0882 13.1072 15.4662 12.6328 17.3624 12.7166L17.1936 15.5577H17.0247C14.5652 15.5577 13.4346 16.9331 13.4346 19.5126V24.1893H10.2313V12.8945V12.8958Z"
          fill="var(--rl-logo-text, #fff)"
        />
        <path
          d="M33 16.5C23.8876 16.5 16.5 9.11367 16.5 0L33 16.5Z"
          fill="#A6F075"
        />
      </svg>
    </span>
  );
};

/** Brand-aware sidebar logo — renders the logo from the active brand config */
export const Logo = () => {
  const brand = useBrand();
  const LogoComponent = brand.logos.sidebarLogo;

  return <LogoComponent />;
};
